/**
 * Show a notice the server never got a chance to send.
 *
 * Quantities that run into the input's `max` are clamped by the browser before anything is
 * submitted, so WooCommerce sees no change, says nothing, and the customer is left looking at
 * whatever notice was on screen already. This puts the explanation on screen in WooCommerce's
 * own markup, styled the same way as any server-sent notice.
 *
 * Goes straight to #wc-toast-container instead of `.woocommerce-notices-wrapper`: on a guest
 * with no WC session cookie yet (e.g. wishlist on a product list, before anything is in the
 * cart), `handleWooCommerceNotices()` removes that wrapper and never starts observing, so a
 * notice appended to it would never get wrapped and would render unstyled.
 */

import { getOrCreateToastContainer, handleNotice } from "../components/notices";

const TOAST_ITEM_SELECTOR = "#wc-toast-container .wc-toast-item";

export const showCartNotice = (message, variant = "woocommerce-info") => {
  const text = message?.trim();

  if (!text) return;

  document.querySelectorAll(TOAST_ITEM_SELECTOR).forEach((item) => {
    if (item.textContent.trim() === text) item.remove();
  });

  const notice = document.createElement("div");

  notice.className = variant;
  notice.setAttribute("role", "alert");
  notice.textContent = text;

  handleNotice(notice, getOrCreateToastContainer());
};
